import { Map as ImmutableMap, fromJS } from 'immutable';
import { FETCH_TEAMS_STARTED, FETCH_TEAMS_SUCCEEDED } from '../actions/ActionTypes';
import { STARTED, UNINITIALIZED, SUCCEEDED } from '../constants/RequestStatusTypes';
const initialState = ImmutableMap({
  status: UNINITIALIZED,
  teams: ImmutableMap()
});
export default function teams(state = initialState, action) {
  switch (action.type) {
    case FETCH_TEAMS_STARTED:
      return state.merge({
        status: STARTED
      });
    case FETCH_TEAMS_SUCCEEDED:
      {
        const {
          payload
        } = action;
        return state.merge({
          status: SUCCEEDED,
          teams: fromJS(payload)
        });
      }
    default:
      return state;
  }
}